module.exports = __webpack_public_path__ + "img/about-fair-002.df1aae4c.jpg";